import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { getLocalLicenseQueryKey, getServerTimeQueryKey } from "../queryKeys";
import api from "../api";
import { show } from "../../../notifications/notifications";
import { NotificationsLevel } from "../../../lib/enums";
import {
  checkIsLicenseValidOrOnline,
  formatExpiryDate,
  isLicenseExpiring
} from "../utils";

const useLocalLicense = () => {
  const {
    data: localLicenseData,
    isPending: isLocalLicenseLoading,
    isError: isLocalLicenseError
  } = useQuery({
    queryKey: getLocalLicenseQueryKey,
    queryFn: api.getLocalLicense
  });

  const {
    data: serverTimeData,
    isPending: isServerTimeLoading,
    isError: isServerTimeError
  } = useQuery({
    queryKey: getServerTimeQueryKey,
    queryFn: api.getServerTime
  });

  useEffect(() => {
    if (isLocalLicenseError || isServerTimeError) {
      show({
        level: NotificationsLevel.ERROR,
        message: "Error while fetching license..."
      });
    }
  }, [isLocalLicenseError, isServerTimeError]);

  const localLicenseFormatted = {
    ...localLicenseData?.data,
    expiryDate: formatExpiryDate(localLicenseData?.data?.expiryDate)
  };

  return {
    localLicense: localLicenseFormatted,
    isLocalLicenseLoading: isLocalLicenseLoading || isServerTimeLoading,
    isLocalLicenseValidOrOnline: checkIsLicenseValidOrOnline(
      localLicenseFormatted?.status
    ),
    isLocalLicenseExpiring:
      !!serverTimeData?.data &&
      isLicenseExpiring(
        localLicenseFormatted.expiryDate,
        serverTimeData.data.serverTime
      )
  };
};

export default useLocalLicense;
